import React, { useEffect } from 'react';
import Select from 'react-select';
import {
  sendDataToLocalSigner,
  sendDataToOtherLocalSigner,
} from '../../redux/transaction/transaction.actions';
import { showCloudCertModal } from '../../redux/cloud-cert-modal/cloud-cert-modal.actions';
import { fetchUserInfoAsync } from '../../redux/user/user.actions';
import { selectTsp } from '../../redux/tsp/tsp.actions';
import EsignOverview from '../esign-overview/esign-overview.component';

import signIcon from '../../images/sign-icon.svg';
import pdfIcon from '../../images/pdf-icon.svg';
import xmlIcon from '../../images/xml-icon.svg';

import './esign-content.style.scss';

const EsignContent = ({ data, user, dispatch, tsp }) => {
  const icon =
    data && data.mimetype.toLowerCase() === 'xml' ? xmlIcon : pdfIcon;

  const selectedTsp = tsp && tsp.selectedTsp ? tsp.selectedTsp : null;

  const filterdProviders = tsp.providers.filter(
    (provider) => provider.type === 'cloud',
  );

  useEffect(() => {
    if (localStorage.getItem('selectedTsp')) {
      const persistTsp = JSON.parse(localStorage.getItem('selectedTsp'));
      dispatch(selectTsp(persistTsp));
    }
  }, [dispatch]);

  const title =
    (data && data.signatureType) === 'sign'
      ? 'Potpisivanje dokumenta'
      : 'Pečatiranje dokumenta';

  const info =
    (data && data.signatureType) === 'sign'
      ? 'Klikom na gumb "Nastavi" provesti će se potpisivanje dokumenta'
      : 'Klikom na gumb "Nastavi" provesti će se pečatiranje dokumenta';

  const handleOnClickLocal = () => {
    dispatch(sendDataToLocalSigner(data, selectedTsp));
  };

  const handleOnClickCloud = () => {
    const { token } = data;
    dispatch(fetchUserInfoAsync(selectedTsp, token));

    dispatch(showCloudCertModal());
  };

  const handleOnClickOther = () => {
    dispatch(sendDataToOtherLocalSigner(data, selectedTsp));
  };

  const handleChange = (option) => {
    localStorage.setItem('selectedTsp', JSON.stringify(option));

    dispatch(selectTsp(option));
  };

  return data ? (
    <div className="esign-content">
      <h1>{title}</h1>
      <p>{info}</p>
      <div className="document-container">
        <div className="document-icon-wrap">
          <img className="document-icon" src={icon} alt="" />
        </div>
        <div className="document-wrap">
          <p className="document-title">
            Pružatelj usluge:{' '}
            <span className="document-subtitle">
              Ministarstvo pravosuđa, uprave i digitalne transformacije
            </span>
          </p>
          <p className="document-title">
            Naziv usluge:{' '}
            <span className="document-subtitle">
              Usluga za elektroničko potpisivanje dokumenata
            </span>
          </p>
          <p className="document-title">
            Verifikacijski kod:{' '}
            <span className="document-subtitle">
              {data.documents[0].verificationCode}
            </span>
          </p>
        </div>
        <div className="tsp-wrap">
          <h4>Odaberite pružatelja usluga povjerenja</h4>
          <Select
            className="select-tsp"
            placeholder="Odabir..."
            value={tsp.selectedTsp}
            isSearchable={false}
            onChange={handleChange}
            options={tsp.providers}
          />
          <Select
            className="select-tsp-mobile"
            placeholder="Odabir..."
            value={tsp.selectedTsp}
            isSearchable={false}
            onChange={handleChange}
            options={filterdProviders}
          />
        </div>
      </div>

      <div className="sign-buttons">
        {selectedTsp && (
          <div>
            {selectedTsp.internal &&
              selectedTsp.type.toLowerCase() === 'card' && (
                <button className="sign-button" onClick={handleOnClickLocal}>
                  {' '}
                  <img className="sign-icon" src={signIcon} alt="" />
                  Nastavi
                </button>
              )}

            {!selectedTsp.internal &&
              selectedTsp.type.toLowerCase() === 'card' && (
                <button className="sign-button" onClick={handleOnClickOther}>
                  {' '}
                  <img className="sign-icon" src={signIcon} alt="" />
                  Nastavi
                </button>
              )}

            {selectedTsp.type.toLowerCase() === 'cloud' && user && (
              <button
                className="sign-button sign-button-cloud"
                onClick={handleOnClickCloud}
              >
                <img className="sign-icon" src={signIcon} alt="" />
                Nastavi
              </button>
            )}

            {selectedTsp.type.toLowerCase() === 'cloud' && !user && (
              <div>
                <p>
                  Udaljeni certifikat Vam mora biti izdan te morate biti
                  prijavljeni kako biste ga mogli koristiti.
                </p>
                <p>
                  Proces prijave se inicira klikom na gumb "Prijava" gore desno
                  u alatnoj traci
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : (
    <EsignOverview />
  );
};

export default EsignContent;
